import React from 'react'
import { Modal } from './Modal'
import { Col, Container, Row } from 'react-bootstrap'
import { Button } from '../Button/Button'

export interface YesNoCancelModalProps {
  show: boolean
  onHide: () => void
  message: string
  onYes: () => void
  onNo: () => void
}

export const YesNoCancelModal: React.FC<YesNoCancelModalProps> = ({ show, onHide, message, onYes, onNo }) => {
  return (
    <Modal
      body={
        <Container>
          <Row>
            <Col>{message}</Col>
          </Row>
        </Container>
      }
      header={<></>}
      footer={
        <Container>
          <div className='d-flex justify-content-between'>
            <Button variant='secondary' onClick={onHide}>
              Cancel
            </Button>
            <Row className='d-flex gap-3'>
              <Button variant='secondary' onClick={onNo}>
                No
              </Button>
              <Button variant='primary' onClick={onYes}>
                Yes
              </Button>
            </Row>
          </div>
        </Container>
      }
      centered={true}
      show={show}
      onHide={onHide}
    />
  )
}
